import { Injectable } from '@angular/core';
import { Converter, Occ, Page } from '@spartacus/core';

export interface CustomPage extends Page {
  localizedLabel?: string;
  pageUrl?: string;
}

@Injectable()
export class CustomPageNormalizer implements Converter<Occ.CMSPage, CustomPage> {
  convert(source: Occ.CMSPage, target: CustomPage): CustomPage {
    target['page']['localizedLabel'] = source['localizedLabel'];

    if (source['localizedLabel']) {
      const pageCode = source['localizedLabel'];
      target['page']['pageUrl'] = decodeURIComponent(pageCode);
    }

    return target;
  }
}
